import { createUseStyles } from 'react-jss'
import { DARK_GRAY_11, DARK_GRAY_05, WHITE_83 } from '@styles/colors'

export default createUseStyles({
  card: {
    backgroundColor: 'var(--secondary__page__background__color)',
    boxShadow: `0px 0px 3px ${DARK_GRAY_11}, 0px 4px 15px ${DARK_GRAY_05}`,
    color: 'var(--body__text__color)',
    position: 'relative',
    overflow: 'hidden',
    maxWidth: '100%'
  },
  header: {
    backgroundColor: 'var(--primary__page__background__color)',
    alignItems: 'stretch',
    boxShadow: `0 0.125em 0.25em ${DARK_GRAY_11}`,
    display: 'flex',
    padding: 14
  },
  image: {
    display: 'block',
    position: 'relative',
    '& img': {
      backgroundColor: WHITE_83,
      borderRadius: '5px',
      display: 'block',
      height: 'auto',
      width: '100%'
    }
  },
  cardContent: {
    backgroundColor: 'transparent',
    padding: 24
  },
  media: {
    marginBottom: '1.5rem',
    alignItems: 'flex-start',
    display: 'flex',
    textAlign: 'left'
  },
  title: {
    color: 'var(--title__text__color)',
    fontSize: '1.5rem',
    marginBottom: '1.5rem',
    fontWeight: 'bold',
    lineHeight: '1.125',
    wordBreak: 'break-word'
  },
  subTitle: {
    marginTop: '-1.25rem',
    color: 'var(--body__text__color)',
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: '1.25',
    wordBreak: 'break-word'
  },
  columns: {
    '&:not(:last-child)': {
      marginBottom: 'calc(1.5rem - 0.75rem)'
    },
    '@media (max-width: 700px)': {
      display: 'block'
    },
    display: 'flex',
    marginLeft: '-0.75rem',
    marginRight: '-0.75rem',
    marginTop: '-0.75rem'
  },
  columnLabel: {
    flex: 'none',
    width: '8.33333%',
    display: 'block',
    padding: '0.75rem'
  },
  columnItem: {
    display: 'block',
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 1,
    padding: '0.75rem'
  }
})
